import { createFileRoute } from '@tanstack/react-router'
import { ChannelConnection } from '../../../../components/ChannelConnection'

export const Route = createFileRoute('/platform/desa/$desaId/channel')({
  component: () => {
    const { desaId } = Route.useParams()
    return <ChannelConnection desaId={desaId} />
  },
})
